module.exports = __webpack_public_path__ + "static/img/mamanvogue-05.c42762e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mamanvogue-05.webp
// module id = 116
// module chunks = 0